"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionSchema = void 0;
const zod_1 = require("zod");
const identity_1 = require("../identity");
exports.SessionSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    email: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    role: identity_1.RoleSchema,
});
